(ns ycweb.app.admin.finance.ebucksbackup.ebucksbackup
  "Manual fallback for the monthly eBucks allocations upload. Temporary, see
  ycweb.app.admin.finance.ebucksbackup.api.ebucksbackup."
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.finance.common :as fincommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]))

(defn- load-files [app-atom]
  (toaster/open-overlay app-atom :admin.ebucksbackup/list)
  (comms/send :admin.ebucksbackup/list {}))

(defmethod comms/receive :admin.ebucksbackup/list [app-atom {:keys [success pending sent]}]
  (toaster/close-overlay app-atom :admin.ebucksbackup/list)
  (if success
    (swap! app-atom update :admin.ebucksbackup assoc :pending pending :sent sent)
    (toaster/open-toast app-atom :error "Couldn't build the eBucks files" {})))

(defn- receive-result [app-atom action {:keys [success msg] :as result}]
  (toaster/close-overlay app-atom :admin.ebucksbackup/list)
  (if success
    (do
      (swap! app-atom update :admin.ebucksbackup
        #(-> %
           (assoc :result (assoc result :action action))
           (dissoc :undo-filename)))
      (load-files app-atom))
    (toaster/open-toast app-atom :error msg {})))

(defmethod comms/receive :admin.ebucksbackup/mark-sent [app-atom result]
  (receive-result app-atom :marked result))

(defmethod comms/receive :admin.ebucksbackup/undo-sent [app-atom result]
  (receive-result app-atom :undone result))

(defmethod grid/action :admin.ebucksbackup/download [_ {:keys [filename data]} _]
  (fincommon/download-file data filename "text/plain"))

(defmethod grid/action :admin.ebucksbackup/confirm-mark-sent [app-atom {:keys [filename fingerprint record-count]} _]
  (grid/confirm-modal app-atom
    {:title (str "Mark " filename " as sent?")
     :text
     [:p
      (str "This marks its " record-count " claims as sent to eBucks, so the cron won't send them again. "
        "Only do this once the file has been sent. You can undo it on this page.")]
     :confirm-text "Mark as sent"
     :confirm-key :admin.ebucksbackup/mark-sent
     :filename filename
     :fingerprint fingerprint}))

(defmethod grid/action :admin.ebucksbackup/mark-sent [app-atom {:keys [filename fingerprint]} _]
  (toaster/open-overlay app-atom :admin.ebucksbackup/list)
  (comms/send :admin.ebucksbackup/mark-sent {:filename filename :fingerprint fingerprint}))

(defmethod grid/action :admin.ebucksbackup/confirm-undo-sent [app-atom {:keys [filename]} _]
  (grid/confirm-modal app-atom
    {:title (str "Undo " filename "?")
     :text
     [:p
      "Its claims go back to pending: the file is listed here again to resend, "
      "and the cron sends them once it uploads again."]
     :confirm-text "Undo"
     :negative true
     :confirm-key :admin.ebucksbackup/undo-sent
     :filename filename}))

(defmethod grid/action :admin.ebucksbackup/undo-sent [app-atom {:keys [filename]} _]
  (toaster/open-overlay app-atom :admin.ebucksbackup/list)
  (comms/send :admin.ebucksbackup/undo-sent {:filename filename}))

(rum/defc result-feedback [{:keys [action filename order-ids]}]
  (feedback/feedback :success
    (if (= :marked action)
      (str "Marked " (count order-ids) " claims in " filename " as sent")
      (str (count order-ids) " claims in " filename " are pending again"))
    ;; Rendered inside a <p>, so spans rather than divs.
    [[:span {:style {:display "block"}} "Orders:"]
     [:span {:style {:display "block" :max-height "160px" :overflow-y "auto" :font-family "monospace"}}
      (apply str (interpose ", " order-ids))]]))

(rum/defc pending-table [app-atom pending]
  [:table {:class (u/bem :oTable [:has-shadow])}
   [:thead
    [:tr
     [:th "File"]
     [:th.u-text-right "Claims"]
     [:th.u-text-right "eBucks (header)"]
     [:th.u-text-right "Rand total (header)"]
     [:th]]]
   [:tbody
    (for [{:keys [filename record-count ebucks-total rand-total] :as file} pending]
      [:tr {:key filename}
       [:td filename]
       [:td.u-text-right record-count]
       [:td.u-text-right ebucks-total]
       [:td.u-text-right rand-total]
       [:td.u-text-right
        (buttons/button-web "Download"
          {:type :button
           :style :secondary
           :size :small
           :on-click #(grid/dispatch-action app-atom :admin.ebucksbackup/download file)})
        " "
        (buttons/button-web "Mark as sent"
          {:type :button
           :style :primary
           :size :small
           :on-click #(grid/dispatch-action app-atom :admin.ebucksbackup/confirm-mark-sent file)})]])]])

(rum/defc sent-table [app-atom sent]
  [:table {:class (u/bem :oTable [:has-shadow])}
   [:thead
    [:tr
     [:th "File"]
     [:th.u-text-right "Claims"]
     [:th "Marked as sent"]
     [:th]]]
   [:tbody
    (for [{:keys [filename claims datesent]} sent]
      [:tr {:key filename}
       [:td filename]
       [:td.u-text-right claims]
       [:td (ud/format-date (* 1000 datesent) "yyyy-MM-dd HH:mm")]
       [:td.u-text-right
        (buttons/button-web "Undo"
          {:type :button
           :style :secondary
           :size :small
           :on-click #(grid/dispatch-action app-atom :admin.ebucksbackup/confirm-undo-sent {:filename filename})})]])]])

(rum/defc ebucks-backup < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        pending (cmn/curact process-atom :pending)
        sent (cmn/curact process-atom :sent)
        result (cmn/curact process-atom :result)
        undo-filename (cmn/curact process-atom :undo-filename)]
    [:<>
     [:div.admin-react-wrapper__content
      (headings/heading "eBucks allocations backup" {:type :h1 :size :large})
      [:p
       "While the SFTP upload is down: download each month's file, send it to eBucks, "
       "then mark it as sent so the cron doesn't send those claims again. "
       "Each file is what the cron would upload for that month's claims."]]

     (when result
       (result-feedback result))

     (headings/heading "Pending" {:type :h2 :size :default})
     (if (seq pending)
       (pending-table app-atom pending)
       [:p "No pending claims in whole months older than a week."])

     (headings/heading "Marked as sent" {:type :h2 :size :default})
     (if (seq sent)
       (sent-table app-atom sent)
       [:p "No files from this page are marked as sent."])

     [:div.form.u-max-width-640.u-margin-bottom-40
      [:div.form-field
       [:label.form-label "Undo any file by name (including cron files):"]
       (forms/input-raw "YUPPIECHEFAllocations….DAT" (rum/cursor process-atom :undo-filename) {})]
      (buttons/button-web "Undo"
        {:type :button
         :style :secondary
         :size :small
         :disabled (empty? undo-filename)
         :on-click #(grid/dispatch-action app-atom :admin.ebucksbackup/confirm-undo-sent {:filename undo-filename})})]

     (toaster/loading-overlay app-atom :admin.ebucksbackup/list)]))

(defmethod t/transition-after-open :admin.ebucksbackup [app-atom _ _]
  (load-files app-atom))

(defmethod flow/render-screen :admin.ebucksbackup [app-atom _]
  (ebucks-backup app-atom))
